export default class FontState {
  family = String;
  weight = Number;
  size = Number;
}
